import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizensServicesDeliveryChannel} from './citizens-services-delivery-channel.model';

export const loadCitizensServicesDeliveryChannels = createAction(
  '[CitizensServicesDeliveryChannel/API] Load CitizensServicesDeliveryChannels',
  props<{ citizensServicesDeliveryChannels: CitizensServicesDeliveryChannel[] }>()
);

export const addCitizensServicesDeliveryChannel = createAction(
  '[CitizensServicesDeliveryChannel/API] Add CitizensServicesDeliveryChannel',
  props<{ citizensServicesDeliveryChannel: CitizensServicesDeliveryChannel }>()
);

export const upsertCitizensServicesDeliveryChannel = createAction(
  '[CitizensServicesDeliveryChannel/API] Upsert CitizensServicesDeliveryChannel',
  props<{ citizensServicesDeliveryChannel: CitizensServicesDeliveryChannel }>()
);

export const addCitizensServicesDeliveryChannels = createAction(
  '[CitizensServicesDeliveryChannel/API] Add CitizensServicesDeliveryChannels',
  props<{ citizensServicesDeliveryChannels: CitizensServicesDeliveryChannel[] }>()
);

export const upsertCitizensServicesDeliveryChannels = createAction(
  '[CitizensServicesDeliveryChannel/API] Upsert CitizensServicesDeliveryChannels',
  props<{ citizensServicesDeliveryChannels: CitizensServicesDeliveryChannel[] }>()
);

export const updateCitizensServicesDeliveryChannel = createAction(
  '[CitizensServicesDeliveryChannel/API] Update CitizensServicesDeliveryChannel',
  props<{ citizensServicesDeliveryChannel: Update<CitizensServicesDeliveryChannel> }>()
);

export const updateCitizensServicesDeliveryChannels = createAction(
  '[CitizensServicesDeliveryChannel/API] Update CitizensServicesDeliveryChannels',
  props<{ citizensServicesDeliveryChannels: Update<CitizensServicesDeliveryChannel>[] }>()
);

export const deleteCitizensServicesDeliveryChannel = createAction(
  '[CitizensServicesDeliveryChannel/API] Delete CitizensServicesDeliveryChannel',
  props<{ id: string }>()
);

export const deleteCitizensServicesDeliveryChannels = createAction(
  '[CitizensServicesDeliveryChannel/API] Delete CitizensServicesDeliveryChannels',
  props<{ ids: string[] }>()
);

export const clearCitizensServicesDeliveryChannels = createAction(
  '[CitizensServicesDeliveryChannel/API] Clear CitizensServicesDeliveryChannels'
);


//CUSTOM

export const citizenGetServicesDeliveryChannels = createAction(
  '[CitizensServicesDeliveryChannel/API] Citizen Get Services Delivery Channels',
  props<{ serviceUniqueId: string}>()
);
